import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppOAuthStore } from '../models/AppOAuthSotarge';
import { verticalMenuItems } from '../theme/components/menu/menu';
import { Menu } from '../theme/components/menu/menu.model';
import { httpConnect } from './httpConnect.service';
// 2021-08-13 (aaangeles) CREACION
@Injectable()
export class GuardianService implements CanActivateChild {
    public menuss: Array<Menu> = verticalMenuItems;
    constructor( private router : Router , private myStorage: AppOAuthStore,  private httpConn: httpConnect ) { }
    // canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    //     throw new Error('Method not implemented.');
    // }
    canActivateChild( route : ActivatedRouteSnapshot, state : RouterStateSnapshot ) : Promise<boolean> {
        if (route.routeConfig.path == '' || (route.routeConfig.path == 'frapDigital' && !!this.myStorage.getItem('id_personal'))) return of(true).toPromise();
        return new Promise((resolve) => {
            let menu = this.menuss.find(m => m.routerLink == (state.url)).id_menu;
            this.getPermisoVista(menu)
            .subscribe(res => {
                if(res.length == 0 && menu != 'Home'){                
                    this.myStorage.clear();
                    this.router.navigate(['/']);    
                    resolve(false);                 
                } 
                else if(res.length > 0 && menu == "Home") {
                    if (JSON.parse(this.myStorage.getItem("permisos"))?.find(p => (p.desc_modulo + ' / ' + p.desc_permiso) == 'Módulo Reportes / Tablero de Socorros')) {
                        this.router.navigate(['/tableroSocorros']); 
                    }
                    resolve(true);
                }
                else {
                    resolve(true);
                }
            }, err => {
                console.log(err)
                this.router.navigate(['/']);  
                resolve(false);
            })
        })
    }

    private getPermisoVista(menu : string){
        let permiso = menu == 'Home' ? 0 : JSON.parse(this.myStorage.getItem("permisos"))?.find(p => (p.desc_modulo + ' / ' + p.desc_permiso) == menu);
        if (menu != 'Home' && !!!permiso) return of([]);

        let params = {
            id_permiso : permiso.id_permiso, 
            id_perfil : this.myStorage.getItem('id_perfil')
        }
        
        return this.httpConn.postAPI('Seguridad', 'GetPermisoVista', params)
        .pipe(
            map((data: any) =>{
                return data.response;
            })
            ,catchError(err =>{
                return throwError(err.error);
            })
        ) 
      }
}